import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/scss/theme.scss';

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import * as Sentry from '@sentry/react';

import { TransactionProvider } from './contexts/TransactionContext';

import { Cart } from './pages/cart';
import Payment from './pages/payment';
import Login from './pages/login';

Sentry.init({
  dsn: 'https://7bb99c25356eb349f62f66f625c52744@o877906.ingest.us.sentry.io/4508870369345536',
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  maxMessageLength: 10000,
  normalizeDepth: 10,
});

function App() {
  return (
    <TransactionProvider>
      <BrowserRouter>
        <div className='site-page'>
          <Routes>
            <Route
              path='/'
              element={<Login />}
            />
            <Route
              path='/carrinho'
              element={<Cart />}
            />
            <Route
              path='/pagamento'
              element={<Payment />}
            />
          </Routes>
        </div>
      </BrowserRouter>
    </TransactionProvider>
  );
}

export default App;
